import React, { Component } from 'react';

import Chart from './charts/Chart';
import { format } from "d3-format";
import timeunit from "timeunit";
import { Finance } from 'financejs'

class Graph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null
    };
    this._loadData();
  }

  _loadData() {
    fetch(this.props.url)
      .then((rsp) => rsp.json()) // Transform the data into json
      .then((raw) => {
        var ds = [];
				const algo_return = raw.algorithm_period_return;
				const bm_data = raw.benchmark_period_return;
				var dates = Object.keys(algo_return);
				var lastDate = dates[dates.length - 1];
				dates.map( dt => {
					var ddd = [
						parseInt(dt, 10),
						algo_return[dt],
						bm_data[dt]
					];
					ds.push(ddd);
					return null;
				});
				var totalBenchmarkReturn = bm_data[lastDate];
				var totalAlgoReturn = algo_return[lastDate];
				var alpha = raw.alpha;
				var max_drawdown = raw.max_drawdown;
				var beta = raw.beta;
				var sharpe = raw.sharpe;
				var sortino = raw.sharpe;
				var volatility = raw.algo_volatility;

        let _cagr_calc = (initial, final, diff) => Math.pow((final / initial), (1 / diff)) - 1;
        const yearDiff = timeunit.days.convert(lastDate - dates[0] - timeunit.days.toMillis(1), timeunit.milliseconds) / 365.2425;
				const finance = new Finance();
        var cagr_benchmark = finance.CAGR(1, totalBenchmarkReturn + 1, yearDiff) / 100;
        var cagr_portfolio = finance.CAGR(1, totalAlgoReturn + 1, yearDiff) / 100;
        this.setState({
          data: ds,
          totalBenchmarkReturn,
          totalAlgoReturn,
          alpha,
          beta,
          max_drawdown,
          sharpe,
          sortino,
          volatility,
          cagr_benchmark,
          cagr_portfolio
        });
      });
  }

  render() {
		const twoDigitPercentage = format(".2%");
		const twoDigit = format(".2f");
    let loading = () =>
      <div>Loading...</div>;
    let chart = () =>
			<div>
				<div className="graph-wrapper">
					<div className="graph-item">
						<label>Portfolio Returns</label>
						<p>{twoDigitPercentage(this.state.totalAlgoReturn)}</p>
					</div>
					<div className="graph-item">
						<label>Portfolio Annualized</label>
						<p>{twoDigitPercentage(this.state.cagr_portfolio)}</p>
					</div>
					<div className="graph-item">
						<label>SP500 Returns</label>
						<p>{twoDigitPercentage(this.state.totalBenchmarkReturn)}</p>
					</div>
					<div className="graph-item">
						<label>SP500 Annualized</label>
						<p>{twoDigitPercentage(this.state.cagr_benchmark)}</p>
					</div>
					<div className="graph-item">
						<label>Alpha</label>
						<p>{twoDigit(this.state.alpha)}</p>
					</div>
					<div className="graph-item">
						<label>Beta</label>
						<p>{twoDigit(this.state.beta)}</p>
					</div>
					<div className="graph-item">
						<label>Sharpe</label>
						<p>{twoDigit(this.state.sharpe)}</p>
					</div>
					<div className="graph-item">
						<label>Sortino</label>
						<p>{twoDigit(this.state.sortino)}</p>
					</div>
					<div className="graph-item">
						<label>Volatility</label>
						<p>{twoDigit(this.state.volatility)}</p>
					</div>
					<div className="graph-item">
						<label>Max Drawdown</label>
						<p>{twoDigitPercentage(this.state.max_drawdown)}</p>
					</div>
				</div>
				<Chart data={this.state.data} />
			</div>
    return (
      <div>
        {this.state.data ? chart() : loading()}
      </div>
    );
  }
}

export default Graph;



// WEBPACK FOOTER //
// ./src/components/Graph.js